import { Loader } from '@googlemaps/js-api-loader';
import googleMapStyle from './google-map-style.json';
import { decodeEntities } from '@wordpress/html-entities';

document.addEventListener("DOMContentLoaded", function () {
	//check if container of Survey exists
	const htmlMapContainer = document.getElementById("partner-map");

	//load partner's location
	if (htmlMapContainer) { loadPartnerLocation( htmlMapContainer ); }
});

const loader = new Loader({
	apiKey: "AIzaSyBGH20fBjrpXMF83xpH-z3XXcYy9cbYGC0",
	version: "weekly",
	libraries: ["places"]
});

const mapOptions = {
  //Belgium location centre
	center: {
		lat: 50.5991475,
		lng: 4.3915917
	},
	zoom: 15,
	scrollwheel: false,
  //styled using Google Wizard
	styles: googleMapStyle
};

const getScriptData = () => {
	const scriptTag = document.getElementById("cdce-partner-map-script-js");
	const dataset   = scriptTag.dataset
	const nonce     = dataset.nonce;
	const baseUrl   = dataset.baseUrl;
	const postId    = dataset.postId;
	
  return {
		nonce: nonce,
		baseUrl: baseUrl,
    	postId: postId
	};
}

const loadPartnerGoogleMap = (htmlMapContainer, partnerLocation, title) =>{

    if( partnerLocation.lat && partnerLocation.lng ){
      // update location
      mapOptions.center = partnerLocation;
      // Promise
      loader
        .load()
        .then((google) => { return new google.maps.Map(htmlMapContainer, mapOptions); })
        .then(
          map => {
			const contentString = `<p>${title}</p>`;
			const partnerMarker = new google.maps.Marker({ position: partnerLocation, map, animation: google.maps.Animation.DROP }); 
			const partnerInfoWin= new google.maps.InfoWindow({ content: contentString });

			partnerMarker.addListener("click", () => {
				partnerInfoWin.open({
				  anchor: partnerMarker,
				  map,
				  shouldFocus: false,
				});
			  });

			}
        )
        .catch(e => {
          console.error( "map error" );
        });
    }

}

const loadPartnerLocation = ( htmlMapContainer ) => {
	const scriptData  = getScriptData();
  	const nonce       = scriptData.nonce;
  	const postId      = scriptData.postId;
	const url         = `${scriptData.baseUrl}/wp-json/wp/v2/cdce_partner_cpt/${postId}`;

	return fetch(url, {
			method: 'GET',
			credentials: 'include',
			headers: { 'X-WP-Nonce': nonce }
		})
		.then( response => response.json() )
    .then( post => {
      const metas 	   = post.meta;
	  const title	   = decodeEntities( post.title.rendered );
      const partnerLat = metas._partner_lat ? Number(metas._partner_lat) : "";
      const partnerLng = metas._partner_lng ? Number(metas._partner_lng) : "";

      return { 
		title,
		location: {
			lat: partnerLat, 
			lng: partnerLng
		}
		};
      }
    )
    .then( ({title, location}) => loadPartnerGoogleMap(htmlMapContainer, location, title));
}